import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  embedDropdown: {
    width: 240,
  },
  /**
   * Keeps the callout's own button rendered and clickable while invisible: the visible row is an
   * ordinary MenuItem that forwards its click here. Mounted outside the menu so the CDN bundle
   * loads with the page rather than when the menu first opens.
   */
  hiddenCallout: {
    position: 'absolute',
    width: 1,
    height: 1,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap'
  },
});
